import { GOOGLE_CALENDAR_SELECTED } from './constants';

const updateSelectedCalendars = (selected) =>
  (dispatch) =>
    dispatch({
      type: GOOGLE_CALENDAR_SELECTED,
      payload: { selected },
    });

export default updateSelectedCalendars;
